import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { SnowplowSportContext } from '@/helpers/tracking/providers';
import { ObjectType, SportType } from '@/@types/graphql-types';
import { useRoute } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {

const route = useRoute();

const isExpanded = ref(false);

function handleExpandClick() {
	isExpanded.value = !isExpanded.value;
	const sportType = route.meta?.sport as SportType;
	const sportContext = new SnowplowSportContext(sportType, ObjectType.Sport);
	TrackingHelper.trackEvent('userinteraction', { action: 'read_more_clicked' }, [sportContext]);
}

return { __sfc: true,route, isExpanded, handleExpandClick }
}

})